module.exports = __webpack_public_path__ + "img/2.344d8822.jpg";